import * as Connector from 'shared/connectors/startConnector';
import { START } from 'store/types';

const init = () => ({
  type: START.GET_STATUSES_INIT,
});

const success = data => ({
  type: START.GET_STATUSES_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: START.GET_STATUSES_FAILURE,
});

const getStatuses = () => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getStatuses();
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getStatuses;
